import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6b3147c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recommend" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createTextVNode(" 文章推荐 ")
], -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { class: "top-title" }
const _hoisted_8 = { class: "item-content" }

import { MessageFetch } from '@/api/request';
import { ISjqnwArticleProps } from '@/api/type';
import { onMounted, PropType, ref } from 'vue';
import { useRouter } from 'vue-router';
import config from '../_config';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const list = ref<ISjqnwArticleProps[]>([]);

// const props = defineProps({
//   recommendList: {
//     type: Array as PropType<ISjqnwArticleProps[]>,
//     default: () => []
//   }
// });
const init = async() => {
  const res = await MessageFetch.sjqnwArticleRecommend({
    sjqnwArticleType: '1'
  });
  if (res.code === '00') {
    list.value = res.body;
  }
};
const toArticle = (item: ISjqnwArticleProps) => {
  router.push({ name: 'article', query: { articleId: item.id }});
};
onMounted(() => {
  init();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "item",
          onClick: ($event: any) => (toArticle(item)),
          key: item.id
        }, [
          _createElementVNode("img", {
            src: _unref(config).articleUrl + item?.coverUrl,
            class: "left"
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(item.articleTitle), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.intro), 1)
          ])
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}
}

})